angular.module('unergie.main')
.controller('simulationCtrl', ($scope, $rootScope, $timeout, $state, $sce, Tariff, DataAccessOffers, ReferencesService, ApiUser, BoFeaturesService, ErrorCatcher) => {
    $scope.providerName = BoFeaturesService.get('providerLabel')

    $scope.isActive = (state) => $state.is(state)

    const generateMail = function (simulation, zeroReduc, result, ref) {
        const mail = `${'Bonjour,<br><br>' +
        'Suite à votre demande et après analyse des données que vous nous avez communiquées, voici notre estimation' +
        ' : en conservant la même consommation qu\'aujourd\'hui, vous aurez une facture annuelle d\'environ '}${zeroReduc.total.toFixed(0)
        } € en passant chez ${$scope.providerName} Énergie (contre ${ref.total.toFixed(0)} € chez EDF).<br><br>` +
        `Sachant par ailleurs que ${zeroReduc.percentile} des foyers français comparables au vôtre ont une consommation ` +
        `inférieure, nous pensons que vous pouvez atteindre une baisse de votre consommation de ${Math.abs(simulation.reduction)
        }%. Dans cette hypothèse, ` +
        `votre une facture annuelle serait réduite à ${result.total.toFixed(0)} €. Vous obtiendriez en plus un bonus de ${result.pot.toFixed(0)} € pour récompenser vos ` +
        `économies d'énergie, soit un montant final de ${(result.total - result.pot).toFixed(0)} €.<br>L'économie totale sur votre facture serait donc de ${
            ((ref.total - result.total) + result.pot).toFixed(0)} €.<br><br>` +
        `J'espère avoir répondu à votre question et vous compter prochainement parmi nos clients !<br><br>` +
        `Bien à vous,<br><br>` +
        `Roger de ${$scope.providerName} Énergie`
        return ($scope.mail = $sce.trustAsHtml(mail))
    }

    $scope.prm = undefined
    $scope.selectedCity = undefined

    $scope.reductionSliderOptions = {
        enforceStep: true,
        showTicks: true,
        showTicksValues: true,
        step: 5,
        floor: -15,
        ceil: 5,
        translate(value) {
            return `${value}%`
        },
    }

    $scope.reRenderSlider = () => $timeout(() => $rootScope.$broadcast('rzSliderForceRender'))


    $scope.reRenderSlider()

    $scope.prmInputClass = ''

    const powersBase = [
        { label: '3kVA', value: 3 },
        { label: '6kVA', value: 6 },
        { label: '9kVA', value: 9 },
        { label: '12kVA', value: 12 },
        { label: '15kVA', value: 15 },
        { label: '18kVA', value: 18 },
        { label: '24kVA', value: 24 },
        { label: '30kVA', value: 30 },
        { label: '36kVA', value: 36 },
    ]

    const powersHphc = [
        { label: '6kVA', value: 6 },
        { label: '9kVA', value: 9 },
        { label: '12kVA', value: 12 },
        { label: '15kVA', value: 15 },
        { label: '18kVA', value: 18 },
        { label: '24kVA', value: 24 },
        { label: '30kVA', value: 30 },
        { label: '36kVA', value: 36 },
    ]

    $scope.powers = powersBase

    $scope.calendars = undefined
    ReferencesService.getRef('ot-ps').then((mapping) => ($scope.calendars = mapping.toJSON()))

    $scope.routingTariffs = ['BTINFCUST', 'BTINFLU', 'BTINFLUSC', 'BTINFMUDT']

    const simulationTemplate = {
        provider_offer: 'STANDARD',
        id_p_calendar: 'BASE',
        routing_tariff: 'BTINFCUST',
        max_power: 3,
        reduction: 0,
    }

    $scope.simulation = angular.copy(simulationTemplate)

    ReferencesService.getRef('inseepostcode', true).then((mapping) => ($scope.codes = mapping))

    DataAccessOffers.getOffers().$promise.then((data) => ($scope.offers = _.map(data, 'id'))).catch(ErrorCatcher)

    $scope.simulate = function () {
        $scope.simulation.addr_city_code = $scope.selectedCity.insee_code
        $scope.simulation.plan_id = $scope.calendars[$scope.simulation.id_p_calendar].plan_id
        if ($scope.simulation.id_p_calendar === 'BASE') {
            delete $scope.simulation.hp
            delete $scope.simulation.hc
        } else {
            delete $scope.simulation.base
        }
        if (!angular.isNumber($scope.simulation.reduction)) {
            delete $scope.simulation.reduction
        }
        $scope.result = {}
        return Tariff.simulationV1($scope.simulation).$promise.then((data) => {
            $scope.result = data
            const zeroReduc = angular.copy($scope.simulation)
            zeroReduc.reduction = 0
            return Tariff.simulationV1(zeroReduc).$promise.then((dataZeroReduc) => {
                $scope.zeroReduc = dataZeroReduc
                const refSimulation = angular.copy(zeroReduc)
                refSimulation.provider_offer = 'TRV_REF'
                return Tariff.simulationV1(refSimulation).$promise.then((dataRefSimulation) => {
                    $scope.refResult = dataRefSimulation
                    return generateMail($scope.simulation, $scope.zeroReduc, $scope.result, $scope.refResult)
                })
            }) }).catch(ErrorCatcher)
    }

    $scope.changeCalendar = function () {
        if ($scope.simulation.id_p_calendar === 'BASE') {
            $scope.powers = powersBase
            return ($scope.simulation.routing_tariff = 'BTINFCUST')
        }
        $scope.powers = powersHphc
        $scope.simulation.routing_tariff = 'BTINFMUDT'
        if ($scope.simulation.max_power === 3) {
            return ($scope.simulation.max_power = 6)
        }
    }

    $scope.readyToSimulate = () =>
        !$scope.selectedCity || !$scope.selectedCity.insee_code || (($scope.simulation.id_p_calendar === 'BASE') && !$scope.simulation.base) ||
        (($scope.simulation.id_p_calendar === 'HPHC') && (!$scope.simulation.hc || !$scope.simulation.hp))


    $scope.fetchPrm = function () {
        $scope.fetching = true
        $scope.prmResult = undefined
        return ApiUser.fetchPRM({ id_prm: $scope.prm }).$promise.then((prm) => {
            $scope.prmResult = prm.toJSON()
            if (prm.eligible) {
                $scope.prmInputClass = 'has-success'
                $scope.simulation.id_p_calendar = (prm.plan != null ? prm.plan.id_p_calendar : undefined) || null
                $scope.simulation.routing_tariff = prm.routing_tariff
                $scope.simulation.max_power = prm.power.max
                $scope.selectedCity = _.find($scope.codes, { insee_code: prm.addr.city_code })
                return ApiUser.annualCons({ id_prm: $scope.prm }).$promise.then((annualCons) => {
                    $scope.prmResult.annualCons = annualCons.toJSON()
                    const toAdd = angular.copy(annualCons)
                    delete toAdd.diff
                    _.assignIn($scope.simulation, toAdd)
                    return ($scope.fetching = false)
                })
            }
            $scope.prmInputClass = 'has-error'
            return ($scope.fetching = false)
        }).catch((error) => {
            $scope.fetching = false
            $scope.prmResult = error
            $scope.prmInputClass = 'has-error'
            return ErrorCatcher(error)
        })
    }
})
